export function isIframeEmpty(props) {
    return !props.link;
}
export function isLinkValid(link) {
    if (!link) {
        return false;
    }
    try {
        new URL(link);
    }
    catch (e) {
        return false;
    }
    return true;
}
